import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Button from "../../../../core/et3-button/index";
import getCorePersonalStore from "../../../../stores/core/core-personal-store";
import getReportsStore from "../../../../stores/reports-store";
import { TCorePage } from "../../../../Types";
import ET3Div from "../../../../core/et3-div";
import { colors } from "../../../../core/et3-theme/colors";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";
import React from "react";
import { isPositiveNumber } from "et3-type-guards";
import { getPermissionIDRequired } from "../../../../helpers/et3-has-permission";

const ResolveButtons = withLiteObserverAndTheme<{
  reporterId: number;
  reportedId: number;
  reportId: number;
  pageName: TCorePage;
}>((props) => {
  const { reportedId, pageName, reportId, reporterId } = props;
  const userPermissions = getCorePersonalStore().userPermissions.get();
  const hasUserMessagesPermission = isPositiveNumber(
    userPermissions.indexOf(getPermissionIDRequired("User-Messages")),
    true
  );
  const shouldHide = pageName === "AUDITOR_AUDIT";
  return (
    <ET3Div
      isScrollable={false}
      color={colors.all.transparent}
      isExtendable={false}
      fDirection="column"
      justifyContent="flex-start"
      alignItems="center"
      withShadow={false}
      width={200}
      height={150}
      style={{}}
      onClick={() => {}}
    >
      {hasUserMessagesPermission && (
        <React.Fragment>
          <Et3Button
            size="MEDIUM"
            type="GET"
            text="VIEW_CONVERSATION"
            isEnabled={true}
            onClick={async () => {
              if (pageName === "REPORTS") {
                await getCorePersonalStore().insertAdminEvent({
                  eventName: "GO_TO_CONVERSATIONS",
                  fromPage: "REPORTS",
                  userID: reporterId,
                  extraData: {
                    senderID: reporterId,
                    recipientID: reportedId,
                    reportId
                  }
                });
              }
              getReportsStore().goToViewConversationNewTab({
                senderID: reporterId,
                recipientID: reportedId
              });
            }}
          />
          <Et3Margin top={0} bottom={15} right={0} left={0} />
        </React.Fragment>
      )}
      {shouldHide ? (
        <ET3Div
          isScrollable={false}
          color={colors.all.transparent}
          isExtendable={false}
          fDirection="column"
          justifyContent="center"
          alignItems="center"
          withShadow={false}
          width={0}
          height={0}
          style={{}}
          onClick={() => {}}
        />
      ) : (
        <React.Fragment>
          <Et3Button
            type="APPROVE"
            size="MEDIUM"
            isEnabled={true}
            onClick={async () => {
              await getReportsStore().resolveReport(
                reportId,
                reportedId,
                "resolve"
              );
            }}
            text="RESOLVE"
          />
          <Et3Margin top={15} bottom={0} right={0} left={0} />
          <Et3Button
            type="WARN"
            size="MEDIUM"
            isEnabled={true}
            onClick={async () =>
              await getReportsStore().resolveReport(
                reportId,
                reportedId,
                "email"
              )
            }
            text="EMAIL"
          />
        </React.Fragment>
      )}
    </ET3Div>
  );
});
export default ResolveButtons;
